import { Box, Typography } from "@mui/material";

const CharactersCounterLabel = ({ value, maxCharacters }) => {
  return (
    <>
      {value.length > 0 && (
        <Box display="flex" justifyContent="flex-end">
          <Typography variant="caption">
            {`${value.length} / ${maxCharacters} caracteres`}
          </Typography>
        </Box>
      )}
    </>
  );
};

export default CharactersCounterLabel;
